module.exports = __webpack_public_path__ + "static/media/model_about_en.bf709176.jpg";